<template>
	<div class="tp-DeliveryList">
		<SelectTechnicianModal
			:visibility.sync="isSelectTechnicianVisible"
			@selected="onSelectTechnicianHandler"
		/>

		<!-- client dialog -->
		<el-dialog
			:visible.sync="seeClientDialog"
			title="Informação do cliente"
			size="small"
		>
			<client-card :client="client" />
		</el-dialog>

		<!-- list -------------------------------------------------------------- -->
		<div class="tp-RepairsList__tableContent">
			<RepairsTableReact
				:repairs="problemRepairs"
				:loading="loading"
				:onView="showRepairDetails"
				:onChangeTechnician="changeTechnician"
				:onClientClick="seeClient"
				:showState="false"
			/>

			<!-- pagination ------------------------------------------------------ -->
			<el-pagination
				:current-page="currentPage"
				:page-size="20"
				:total="total"
				class="tp-RepairsList__pagination"
				layout="prev, pager, next"
				@current-change="currentPageChange"
			/>
		</div>
	</div>
</template>
<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { RepairsTable } from "@/components/repair/RepairsTable";
import ClientCardCmp from "../client/ClientCard.vue";
import SelectTechnicianModal from "@/components/technician/select-technician-modal.vue";

const RepairsTableReact = ReactInVue(RepairsTable);

export default {
	components: {
		"client-card": ClientCardCmp,
		SelectTechnicianModal,
		RepairsTableReact,
	},

	data() {
		return {
			isSelectTechnicianVisible: false,

			problemRepairs: [],
			currentPage: 1,

			// loading
			loading: false,
			total: 0,

			// repair details
			selectedRepair: null,
			seeClientDialog: false,

			// client to fill dialog
			client: null,

			selectedClient: "",
		};
	},
	created() {
		// get all repairs in problematic state send in $route
		this.problemRepairs = this.$store.state.route.params.repairs;
	},
	methods: {
		/**
		 * Handle the change of technician.
		 */
		onSelectTechnicianHandler(technician) {
			this.$stellar
				.action("setTechnicianForRepair", {
					id: this.selectedRepair.id,
					technician: technician.id,
				})
				.then(({ repair }) => {
					// show a sucess message
					this.$message({
						message: "O tecnico foi alterado.",
						type: "success",
					});
					// this.loading = false
					// re-fetch the current page
					this.fetchPage(this.currentPage);
				});
		},
		/**
		 * Change the current page for the new one and fetch
		 */
		currentPageChange(newPage) {
			this.currentPage = newPage;
			this.fetchPage(newPage);

			// change the URL to store the current page
			this.updateUrlQuery({ page: newPage });
		},

		seeClient(client) {
			this.client = client;
			this.seeClientDialog = true;
		},

		/**
		 * Show the repair details.
		 */
		showRepairDetails(repair) {
			this.$router.push({ name: "repair.single", params: { id: repair.id } });

			this.selectedRepair = repair;
		},

		/**
		 * Open the list of technicians.
		 */
		changeTechnician(repair) {
			this.selectedRepair = repair;
			this.isSelectTechnicianVisible = true;
		},

		async fetchPage(page = 1) {
			// enable loading
			this.loading = true;

			// update the URL query
			this.updateUrlQuery(
				{
					filters: JSON.stringify(this.filters),
					technician: this.selectedTechnician,
					query: this.searchQuery,
					client: this.selectedClient,
					range: JSON.stringify(this.range),
					page,
				},
				true,
			);

			const options = {
				page,
				limit: 20,
				query: this.searchQuery,
				client: this.selectedClient,
				range: this.range,
				...this.filters,
			};

			// request the page to the API
			const { data, total } = await this.$stellar.action(
				"paginateRepairs",
				options,
			);
			this.total = total;
			this.repairs = data;

			// disable loading
			this.loading = false;
		},
	},
};
</script>
